import { useState, useEffect, useRef, useCallback } from 'react';
import { Button } from "@/components/ui/button";
import { Calendar, X } from "lucide-react";

const StickyBookingButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const ticking = useRef(false);

  // Throttled scroll handler using rAF to prevent forced reflow
  const handleScroll = useCallback(() => {
    if (!ticking.current) {
      requestAnimationFrame(() => {
        // Show button after scrolling 300px
        if (window.scrollY > 300) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
        ticking.current = false;
      });
      ticking.current = true;
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  if (!isVisible || isMinimized) return null;

  return (
    <div className="fixed bottom-6 left-6 z-50 animate-in slide-in-from-bottom-5 duration-500">
      <div className="relative">
        {/* Pulsing glow effect */}
        <div className="absolute inset-0 bg-secondary/20 rounded-full blur-xl animate-pulse"></div>
        
        <div className="relative bg-background/95 backdrop-blur-sm border border-secondary/20 rounded-2xl shadow-2xl p-4 max-w-xs">
          {/* Close button */}
          <button
            onClick={() => setIsMinimized(true)}
            className="absolute -top-2 -right-2 bg-background border border-border rounded-full p-1 hover:bg-muted transition-colors"
          >
            <X className="h-3 w-3" />
          </button>

          {/* Urgency badge */}
          <div className="flex items-center gap-2 mb-3">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-secondary"></span>
            </span>
            <span className="text-xs font-semibold text-secondary">Only 3 slots left this week</span>
          </div>

          {/* CTA Content */}
          <p className="text-sm font-medium mb-3 text-foreground">
            Book Your Free Strategy Call
          </p>
          
          <Button 
            className="w-full bg-secondary hover:bg-secondary/90 text-background font-semibold group"
            size="lg"
            asChild
          >
            <a href="/do-you-qualify">
              <Calendar className="mr-2 h-4 w-4 group-hover:scale-110 transition-transform" />
              Schedule Strategic Review
            </a>
          </Button>

          <p className="text-xs text-muted-foreground mt-2 text-center">
            Free • No obligations • 30 min
          </p>
        </div>
      </div>
    </div>
  );
};

export default StickyBookingButton;
